$(document).ready(function () {
  whenAvailable('owlCarousel', initVideoCarousel);
});


function initVideoCarousel() {
  $('.owl-carousel').owlCarousel({
    stagePadding: 100,
    loop: false,
    margin: 10,
    nav: true,
    responsive: {
      0: {
        items: 1,
        stagePadding: 60
      },
      600: {
        items: 3,
        stagePadding: 100
      },
      1000: {
        items: 3,
        stagePadding: 200
      },
      1200: {
        items: 3,
        stagePadding: 200
      },
      1800: {
        items: 4,
        stagePadding: 60
      }
    },
    autoplay: true,
    autoplayHoverPause: true
  })
  /*
    var playerSettings = {
      controls: ['play-large'],
      fullscreen: { enabled: false },
      resetOnEnd: true,
      hideControls: true,
      clickToPlay: true,
      keyboard: false
    }
  
    /*const players = Plyr.setup('.js-player', playerSettings);
  
    players.forEach(function (instance, index) {
      instance.on('play', function () {
        players.forEach(function (instance1, index1) {
          if (instance != instance1) {
            instance1.pause();
          }
        });
      });
    });
  
    $('.video-section').on('translated.owl.carousel', function (event) {
      players.forEach(function (instance, index1) {
        instance.pause();
      });
    });*/
}

function whenAvailable(name, callback) {
  var interval = 10; // ms
  window.setTimeout(function () {
    if (window[name] || jQuery()[name]) {
      callback(window[name]);
    } else {
      whenAvailable(name, callback);
    }
  }, interval);
}